module.exports = __webpack_public_path__ + "img/file__icon-excel.6bd1d56e.svg";